import * as React from "react";
import './styles.scss'
import {RestDataLoader} from "../../../dashboard/widgets/unilever/RestDataLoader";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";

declare var AppTranslations: AppTranslations;

interface CensusExportProps {
    censusGuid: string;
}

export const CensusExport: React.FC<CensusExportProps> = ({censusGuid}) => {

    const [isExporting, setIsExporting] = React.useState(false);

    const startExport = () => {
        if (!isExporting) {
            setIsExporting(true);
            RestDataLoader.downloadOctetStream(
                `census/${censusGuid}/entries/export`,
                {},
                () => setIsExporting(false),
                () => {
                    console.error();
                    setIsExporting(false);
                },
            );
        }
    };

    return (
        <div
            className={"exportToExcelImgDiv"}
            style={{width: 62, height: 62, display: "inline-block", overflow: "hidden"}}
            onClick={startExport}
        >
            <div
                id="exportToExcelButton"
                className={"exportToExcelButton circleButton entityListButton " + (isExporting ? "loading-cursor exportToExcelButton-disabled" : "")}
                style={{position: "relative", width: 57, height: 57, marginTop: 0}}
            >
                <img
                    id="exportToExcelImg" className="exportToExcelImg"
                    src="images/buttons/icon-excelLogo.png"
                    style={{width: 25, height: 25, top: 16, left: 16}}
                    alt={"Export icon"}
                />
            </div>
        </div>
    )
}